export const billParams = {
  endDate: 'q[created_at_datelteq]',
  payeeId: 'q[payee_id_in][]',
  payorId: 'q[payor_id_in][]',
  search: 'q[load_number_or_invoice_number_cont]',
  startDate: 'q[created_at_dategteq]',
  state: 'q[state_matches_any][]',
} as const;
